import { render, staticRenderFns } from "./ButtonGoogle.vue?vue&type=template&id=f2ed39f8&scoped=true&"
import script from "./ButtonGoogle.vue?vue&type=script&lang=js&"
export * from "./ButtonGoogle.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGoogle.vue?vue&type=style&index=0&id=f2ed39f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed39f8",
  null
  
)

export default component.exports